import { styled } from '@mui/material';
import colors from '../../../../../scss/colors';

const StyledFieldContainer = styled('div')({
  display: 'inline-flex',
  width: '100%',
  verticalAlign: 'top',
  border: `1px solid ${colors.LIGHT_GREY}`,
  borderRadius: '5px 5px 5px 5px',
  alignItems: 'center',
  padding: '10px',
  svg: {
    fontSize: '18px'
  },
  input: {
    fontSize: '12px',
    lineHeight: '14px',
    border: 'none',
    padding: 0,
    marginRight: '6px'
  },
  '@media only screen and (max-width: 997px)': {
    width: '100%',
    borderRadius: '5px',
    '&:first-of-type': {
      borderRadius: '5px'
    }
  }
});

export default StyledFieldContainer;
